<template>
    <div>
        <template v-if="scenario == 'resume'">
            <a-tabs type="card" @change="changeResume" :default-active-key="active" v-if="rid > 0">
                <a-tab-pane key="info" tab="简历信息"></a-tab-pane>
                <a-tab-pane key="visit" tab="拜访记录"></a-tab-pane>
                <a-tab-pane key="manager" tab="分配记录"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'psi'">
            <a-tabs type="card" @change="changePsi" :default-active-key="active" v-if="pid > 0">
                <a-tab-pane key="info" tab="货物信息"></a-tab-pane>
                <a-tab-pane key="log" tab="库存信息"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'enterprise'">
            <a-tabs type="card" @change="changeEnterprise" :default-active-key="active" v-if="eid > 0">
                <a-tab-pane key="info" tab="基本信息"></a-tab-pane>
                <a-tab-pane key="contract" tab="合同信息"></a-tab-pane>
                <a-tab-pane key="job" tab="职位信息"></a-tab-pane>
                <a-tab-pane key="sabill" tab="工资账单"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'job'">
            <a-tabs type="card" @change="changeJob" :default-active-key="active" v-if="jid > 0">
                <a-tab-pane key="info" tab="职位信息"></a-tab-pane>
                <a-tab-pane key="employee" tab="员工列表"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'employee'">
            <a-tabs type="card" @change="changeEmployee" :default-active-key="active" v-if="empid > 0">
                <a-tab-pane key="info" tab="员工信息"></a-tab-pane>
                <a-tab-pane key="contract" tab="合同信息"></a-tab-pane>
                <a-tab-pane key="salary" tab="工资列表"></a-tab-pane>
            </a-tabs>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        scenario: {
            type: [String],
            default: '',
        },
        rid: {
            type: String,
            default: '',
        },
        pid: {
            type: String,
            default: '',
        },
        eid: {
            type: String,
            default: '',
        },
        jid: {
            type: String,
            default: '',
        },
        empid: {
            type: String,
            default: '',
        },
        active: {
            type: String,
            default: '',
        },
    },
    watch: {
    },
    data() {
        return {

        };
    },
    created() {

    },
    methods: {
        // 操作
        optionFun(op) {
            this.$emit('optionFun', {scenario: this.scenario, op: op});
        },
        changeResume(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/resume/edit?rid=' + this.rid);
                    break;
                case 'visit':
                    this.$router.replace('/resume/visit?rid=' + this.rid);
                    break;
                case 'manager':
                    this.$router.replace('/resume/manager?rid=' + this.rid);
                    break;
                default:
                    break;
            }
        },
        changePsi(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/psi/edit?pid=' + this.pid);
                    break;
                case 'log':
                    this.$router.replace('/psi/log-list?pid=' + this.pid);
                    break;
                default:
                    break;
            }
        },
        changeEnterprise(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/enterprise/edit?eid=' + this.eid);
                    break;
                case 'contract':
                    this.$router.replace('/entercontract/list?eid=' + this.eid);
                    break;
                case 'job':
                    this.$router.replace('/job/list?eid=' + this.eid);
                    break;
                case 'sabill':
                    this.$router.replace('/sabill/list?eid=' + this.eid);
                    break;
                default:
                    break;
            }
        },
        changeJob(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/job/edit?jid=' + this.jid);
                    break;
                case 'employee':
                    this.$router.replace('/employee/list?jid=' + this.jid);
                    break;
                default:
                    break;
            }
        },
        changeEmployee(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/employee/edit?empid=' + this.empid);
                    break;
                case 'contract':
                    this.$router.replace('/empcontract/list?empid=' + this.empid);
                    break;
                case 'salary':
                    this.$router.replace('/salary/list?empid=' + this.empid);
                    break;
                default:
                    break;
            }
        },
    }
}
</script>
